"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHandleKeyUp = void 0;
const react_1 = require("react");
const useHandleKeyUp = (onEnterSpace, onEscape) => {
    return (0, react_1.useCallback)((e) => {
        if ((typeof onEnterSpace === "function" && e.key === "Enter") || e.key === " ") {
            if (onEnterSpace) {
                e.preventDefault();
                onEnterSpace(e);
            }
        }
        if (typeof onEscape === "function" && e.key === "Escape") {
            if (onEscape) {
                e.preventDefault();
                onEscape(e);
            }
        }
    }, [onEnterSpace]);
};
exports.useHandleKeyUp = useHandleKeyUp;
//# sourceMappingURL=key.hooks.js.map